import { FiEdit2, FiFileText, FiLock, FiXCircle } from "react-icons/fi";
import { Button } from "../../../../components/shared";
import { useRevokeAIChatGrant } from "../../../../lib/react-query/aiChat";
import { formatToReadableTime } from "../../../../utils/utils";

export const PermissionBar = ({ grant, projectName, sessionId, onChange, canManageAccess }) => {
  const { mutate: revokeGrant, isPending } = useRevokeAIChatGrant();
  if (!sessionId) return null;
  if (projectName) {
    return (
      <div className="border-b border-surface-border bg-white px-4 py-2 text-xs text-primary md:px-6">
        <span className="inline-flex items-center gap-2 font-medium">
          <FiFileText aria-hidden="true" /> Project files available
        </span>
        <span className="ml-2 text-mediumgrey">{projectName}</span>
        {canManageAccess ? (
          <Button variant="transparent" className="ml-3 text-xs" onClick={onChange}>
            <FiEdit2 aria-hidden="true" /> Manage access
          </Button>
        ) : null}
      </div>
    );
  }
  const isActive = grant?.status === "ACTIVE";
  const fileCount = (grant?.sources || []).filter((source) => !source.removed_at).length;
  const fileLabel = `${fileCount} file${fileCount !== 1 ? "s" : ""}`;
  const expiresAt = grant?.expires_at ? new Date(grant.expires_at) : null;
  const expiresSoon = expiresAt && expiresAt.getTime() - Date.now() < 60 * 60 * 1000;

  return (
    <div className="border-b border-surface-border bg-white px-4 md:px-6 py-2">
      <div className="flex flex-wrap items-center gap-2 text-xs">
        <span className={`inline-flex items-center gap-1 rounded-full px-2 py-1 font-medium ${isActive ? "bg-primary/8 text-primary" : "bg-danger/8 text-danger"}`}>
          <FiLock aria-hidden="true" />
          {isActive ? "Access active" : "No access"}
        </span>
        {projectName ? (
          <span className="rounded-full bg-surface px-2 py-1 text-mediumgrey">{projectName}</span>
        ) : null}
        <span className="inline-flex items-center gap-1 rounded-full bg-surface px-2 py-1 text-mediumgrey">
          <FiFileText aria-hidden="true" />
          {fileLabel}
        </span>
        {expiresAt ? (
          <span className={expiresSoon ? "rounded-full bg-warning/15 px-2 py-1 font-medium text-amber-700" : "text-grey"}>
            Expires {formatToReadableTime(expiresAt)}
          </span>
        ) : null}
        <div className="ml-auto flex items-center gap-2">
          <Button variant="transparent" className="h-7 rounded-lg px-2.5 text-xs font-medium text-darkgrey hover:bg-surface-hover" onClick={onChange}>
            <FiEdit2 aria-hidden="true" /> Change
          </Button>
          {isActive ? (
            <Button
              variant="transparent"
              color="danger"
              className="h-7 rounded-lg px-2.5 text-xs font-medium text-danger/70 hover:bg-danger/5 hover:text-danger"
              onClick={() => revokeGrant({ sessionId, reason: "user_revoked" })}
              disabled={isPending}
            >
              <FiXCircle aria-hidden="true" /> Revoke
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
};
